import React from 'react';
import Logo from './logo-prodamus.svg';
import LogoWhite from './logo-prodamus-white.svg';

type LogoProps = {
    theme?: 'light' | 'dark',
    width?: string | number;
    height?: string | number;
}

const ProdamusLogo: React.FC<LogoProps> = ({ theme, width, height }) => {
    return theme === 'light' ? <img src={LogoWhite} width={width} height={height} /> : <img src={Logo} width={width} height={height} />;
}
ProdamusLogo.defaultProps = {
    height: 100
}
export default ProdamusLogo;